import React from 'react';
import { motion } from 'framer-motion';
interface HeroSectionProps {
  title: string;
  subtitle?: string;
  tag?: string;
  bgColor?: 'magenta' | 'cyan' | 'lime' | 'orange' | 'navy';
  textColor?: 'white' | 'navy';
  className?: string;
}
export function HeroSection({
  title,
  subtitle,
  tag,
  bgColor = 'magenta',
  textColor = 'white',
  className = ''
}: HeroSectionProps) {
  const bgColors = {
    magenta: 'bg-brand-magenta',
    cyan: 'bg-brand-cyan',
    lime: 'bg-brand-lime',
    orange: 'bg-brand-orange',
    navy: 'bg-brand-navy'
  };
  const textColors = {
    white: 'text-white',
    navy: 'text-brand-navy'
  };
  return <section className={`relative w-full min-h-[50vh] flex items-center pt-24 pb-16 overflow-hidden ${bgColors[bgColor]} ${className}`} data-id="element-98">
      {/* Abstract Background Shape - subtle texture */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-10 pointer-events-none" data-id="element-99">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full fill-current" data-id="element-100">
          <path d="M44.7,-76.4C58.9,-69.2,71.8,-59.1,81.6,-46.6C91.4,-34.1,98.1,-19.2,95.8,-5.3C93.5,8.6,82.2,21.5,70.6,32.2C59,42.9,47.1,51.4,34.8,58.3C22.5,65.2,9.8,70.5,-1.9,73.8C-13.6,77.1,-24.3,78.4,-34.2,73.8C-44.1,69.2,-53.2,58.7,-61.3,47.4C-69.4,36.1,-76.5,24,-78.6,11.1C-80.7,-1.8,-77.8,-15.5,-70.8,-27.4C-63.8,-39.3,-52.7,-49.4,-40.5,-57.4C-28.3,-65.4,-15,-71.3,-0.6,-70.3C13.8,-69.3,27.6,-61.4,44.7,-76.4Z" transform="translate(100 100)" data-id="element-101" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-103">
          {tag && <span className={`inline-block px-3 py-1 mb-6 text-xs font-bold uppercase tracking-widest bg-white text-brand-black`} data-id="element-104">
              {tag}
            </span>}

          <h1 className={`text-5xl md:text-7xl font-black uppercase leading-[0.9] tracking-tight mb-6 ${textColors[textColor]}`} data-id="element-105">
            {title}
          </h1>

          {subtitle && <p className={`text-xl md:text-2xl font-medium max-w-2xl opacity-90 ${textColors[textColor]}`} data-id="element-106">
              {subtitle}
            </p>}
        </motion.div>
      </div>

      {/* Angled bottom edge */}
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-brand-cream" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 100% 0)'
    }} data-id="element-107"></div>
    </section>;
}